import React from "react";
import {connect} from "react-redux";
import {Modal, message, Switch, DatePicker, Checkbox} from 'antd';

//action imports
import { hideNewAnnouncementModal, announcementsFieldChanged, sendAnnouncement } from "../../../actions/AnnouncementsActions";

//common imports
import { Button } from "../../common/Button";
import {Spinner} from "../../common/Spinner";
import {Input} from "../../common/Input";
import {TextArea} from "../../common/TextArea";

//components import

//file imports

class NewAnnouncement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            profile: this.props.profile,
            legalServices: this.props.legalServices,
            showNewAnnouncementModal: this.props.showNewAnnouncementModal,

            tags: this.props.tags,
            announcementTitle: this.props.announcementTitle,
            announcementDescription: this.props.announcementDescription,
            isPDF: this.props.isPDF,
            isScheduled: this.props.isScheduled,
            deadline: this.props.deadline,
            announcementDate: this.props.announcementDate,
            pdf: this.props.pdf,
            generalNotification: this.props.generalNotification,
            groupNotification: this.props.groupNotification,

            sendAnnouncementLoading: this.props.sendAnnouncementLoading
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.onPDFSwitch = this.onPDFSwitch.bind(this);
        this.handlePDF = this.handlePDF.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props) {
            this.setState({
                legalServices: nextProps.legalServices,
                profile: nextProps.profile,
                showNewAnnouncementModal: nextProps.showNewAnnouncementModal,

                tags: nextProps.tags,
                announcementTitle: nextProps.announcementTitle,
                announcementDescription: nextProps.announcementDescription,
                isPDF: nextProps.isPDF,
                isScheduled: nextProps.isScheduled,
                deadline: nextProps.deadline,
                announcementDate: nextProps.announcementDate,
                pdf: nextProps.pdf,
                generalNotification: nextProps.generalNotification,
                groupNotification: nextProps.groupNotification,

                sendAnnouncementLoading: nextProps.sendAnnouncementLoading
            });
        }
    }

    handleOk = () => {
        this.props.hideNewAnnouncementModal();
    };

    handleCancel = () => {
        this.props.hideNewAnnouncementModal();
    };

    onPDFSwitch() {
        //extract state
        const { isPDF } = this.state;
        this.setState({ isPDF: !isPDF });

        this.props.announcementsFieldChanged({ prop: "isPDF", value: !isPDF });
    }

    onScheduledSwitch() {
        //extract state
        const { isScheduled } = this.state;
        this.setState({ isScheduled: !isScheduled });

        this.props.announcementsFieldChanged({ prop: "isScheduled", value: !isScheduled });
    }

    onDeadlineSwitch() {
        //extract state
        const { deadline } = this.state;
        this.setState({ deadline: !deadline });

        this.props.announcementsFieldChanged({ prop: "deadline", value: !deadline });
    }

    handlePDF(event) {
        const file = event.target.files[0];
        this.props.announcementsFieldChanged({ prop: 'pdf', value: file })
    }

    onDateChange(value) {
        this.props.announcementsFieldChanged({ prop: "announcementDate", value });
    }

    onSave() {
        const { announcementTitle, announcementDescription, isPDF, pdf, isScheduled, deadline, announcementDate, tags, profile } = this.state;

        const access = profile.userAccess.some(access => access === "announcements");

        if (access) {
            if (announcementTitle && announcementDescription) {
                if (isPDF) {
                    if (pdf) {
                        this.props.sendAnnouncement({ announcementTitle, announcementDescription, isPDF, pdf, isScheduled, deadline, announcementDate, tags });
                    } else {
                        message.warning('Please attach pdf file').then();
                    }
                } else {
                    this.props.sendAnnouncement({ announcementTitle, announcementDescription, isPDF, pdf: "", isScheduled, deadline, announcementDate, tags });
                }
            } else {
                message.warning('Fill all the required fields').then();
            }
        } else {
            message.warning("You're not authorized to send an announcement").then();
        }
    }

    renderSendButton() {
        const {sendAnnouncementLoading} = this.state;

        if (sendAnnouncementLoading) {
            return <Spinner/>
        } else {
            return (
                <div className={"newCustomerModalButtonBox"}>
                    <Button
                        text={'Save'}
                        onPress={()=> this.onSave()}
                    />
                </div>
            );
        }
    }

    renderTags() {
        //extract state
        const { legalServices, tags } = this.state;
        const serviceTags = legalServices.map(service => {
            return { label: service.legalServiceTitle, value: service.legalServiceID }
        });

        if (serviceTags.length !== 0) {
            return(
                <div style={{ marginTop: "1rem", marginBottom: "1rem"}}>
                    <Checkbox.Group
                        options={serviceTags}
                        defaultValue={['Apple']}
                        onChange={value => this.props.announcementsFieldChanged({prop: 'tags', value})}
                        value={tags}
                    />
                </div>
            );
        }
    }

    render() {
        return (
            <div className={"newCustomerButtonBox"}>
                <Modal
                    title="Add New Announcement"
                    visible={this.state.showNewAnnouncementModal}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                    width={800}
                >
                    <div className={"formBox"}>
                        <div>
                            <Input
                                label={'Title'}
                                placeholder={"Title"}
                                type={'text'}
                                onChange={e => this.props.announcementsFieldChanged({prop: 'announcementTitle', value: e.target.value})}
                                value={this.state.announcementTitle}
                            />
                        </div>
                        <div>
                            <TextArea
                                label={'Description'}
                                placeholder={"Description"}
                                type={'text'}
                                onChange={e => this.props.announcementsFieldChanged({prop: 'announcementDescription', value: e.target.value})}
                                value={this.state.announcementDescription}
                            />
                        </div>

                        { this.renderTags() }

                        <div>
                            <Switch
                                checkedChildren="PDF Attachment"
                                unCheckedChildren="No PDF"
                                onChange={() => this.onPDFSwitch()}
                                checked={this.state.isPDF}
                            />
                        </div>

                        {
                            this.state.isPDF ?
                                <input
                                    type={'file'}
                                    onChange={this.handlePDF}
                                    accept={"application/pdf"}
                                    // value={this.state.pdf}
                                /> : null

                        }

                        <div>
                            <Switch
                                checkedChildren="Is a deadline"
                                unCheckedChildren="Not deadline"
                                onChange={() => this.onDeadlineSwitch()}
                                checked={this.state.deadline}
                            />
                        </div>

                        <div>
                            <Switch
                                checkedChildren="Scheduled Announcement"
                                unCheckedChildren="Instant Announcement"
                                onChange={() => this.onScheduledSwitch()}
                                checked={this.state.isScheduled}
                            />
                        </div>

                        {
                            this.state.isScheduled ?
                                <DatePicker showTime onChange={this.onDateChange} value={this.state.announcementDate}/>
                            : null

                        }

                        { this.renderSendButton()}
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { showNewAnnouncementModal, announcementTitle, announcementDescription, isPDF, pdf, isScheduled, announcementDate, generalNotification, groupNotification,
        sendAnnouncementLoading, tags, deadline } = state.announcements;

    const { profile } = state.profile;
    const { legalServices } = state.services;

    return {
        profile,
        legalServices,
        showNewAnnouncementModal,

        announcementTitle,
        announcementDescription,
        isPDF,
        pdf,
        isScheduled,
        announcementDate,
        generalNotification,
        groupNotification,

        tags,
        deadline,

        sendAnnouncementLoading,
    }
}

export default connect(mapStateToProps, { hideNewAnnouncementModal, announcementsFieldChanged, sendAnnouncement })(NewAnnouncement);